<script lang="ts">
	import { formatNumber } from 'src/util/format';

	interface Props {
		metadata: Record<string, any>;
	}
	let { metadata }: Props = $props();

	const transformedMetadata = $derived.by(() =>
		Object.entries(metadata).map(([key, value]) => {
			let formatted: string;
			if (typeof value === 'number') {
				formatted = formatNumber(value);
			} else if (typeof value === 'string') {
				formatted = value;
			} else {
				formatted = JSON.stringify(value, null, 2);
			}
			return [key, formatted];
		})
	);
</script>

<div class="meta-list">
	{#each transformedMetadata as [key, value]}
		<div class="meta-row">
			<span class="key">{key}</span>
			<span class="value">{value}</span>
		</div>
	{/each}
</div>

<style lang="scss">
	@use '@astlai/common/styles/mixins' as lib;

	.meta-list {
		@include lib.flex-column();
		border: 1px solid var(--border-subtle);
		border-radius: 0.5rem;
		overflow: hidden;

		.meta-row {
			@include lib.flex-row();
			@include lib.flex-align(space-between);
			gap: 2rem;
			padding: 0.25rem 0.5rem;

			&:nth-last-of-type(2n) {
				background: var(--state-hover);
			}

			.key {
				font-weight: 500;
				flex: 0 0 auto;
			}

			.value {
				text-align: right;
				font-family: 'Monaco', 'Courier New', monospace;
				font-size: 0.875rem;
				color: var(--text-secondary);
			}
		}
	}
</style>
